import parseVideo from './parsers/video';
import parseError from './parsers/error';

import parseUrl from './parse-url';

import * as http from '../../utils/http';


const requestOptions = { withCredentials: false };


export default function (settings) {

  function getByUrl(url) {

    return parseUrl(url)
      .then(function (url) {
        return http.get(`${settings.apiUrl}/oembed.json`, {
            params: { url },
            options: requestOptions,
          })
          .then(function (response) {
            const { data } = response;

            if (data.type !== 'video') {
              return Promise.reject();
            }

            return {
              ...response,
              data: [parseVideo(data)],
            };
          });
      })
      .catch(parseError);
  }

  return {
    getByUrl,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vimeo/videos.js